import { Checkbox, Col, Table } from "antd";
import { ColumnType } from "antd/lib/table";
import { enmControlType, enmPropertyType, IMetadata, IProperty } from "../../components/entityManager/interfaces";
import { BaseComponent, IBaseProps, IBaseStates } from "../../components/infrastructure/baseComponent";
import { enmEntityState, enmOrderingType, ICallOptions, IOrdering, IPaging, IResultSet } from "../../components/infrastructure/models";
import dayjs from 'dayjs';
import CustomSpinner from "../../components/infrastructure/customSpinner";

interface AuditLogItemsStates extends IBaseStates {
    paging: IPaging;
    ordering: IOrdering;
    entities: any[];
    totalResultCount: number;
}
interface AuditLogItemsProps extends IBaseProps {
    entityRowGuid: string;
    metadata: IMetadata;
}

export class AuditLogItems extends BaseComponent<AuditLogItemsProps, AuditLogItemsStates> {
    columns: any;
    constructor(props: AuditLogItemsProps) {
        super(props)
        this.state = {
            isAuthorized: true,
            loading: true,
            windowSize: window.innerWidth <= 765 ? 1 : 2,
            entities: [],
            totalResultCount: 0,
            paging: { PageNo: 1, PageSize: 10 },
            ordering: { OrderBy: enmOrderingType.Ascending, Property: "Id" }
        };
        this.title = 'تاریخچه';
        this.columns = this.getColumns();
    }
    async initialize(paging: IPaging, ordering: IOrdering) {
        let fetchOpt: ICallOptions = {
            url: this.props.metadata.name + "/auditlogitems",
            data: {
                ordering,
                paging,
                entityRowGuid: this.props.entityRowGuid
            },
            onSuccess: (result: IResultSet<any>) => {
                const { Items, TotalCount } = result.Data
                this.setState({ entities: Items, totalResultCount: TotalCount, paging, ordering });
            },
            onError: () => {

            }
        };
        await this.callApi(fetchOpt);
    }
    componentDidMount() {
        super.componentDidMount();
        this.initialize(this.state.paging, this.state.ordering);
    }
    getColumns = () => {
        const properties: IProperty[] = [
            {
                title: "کاربر",
                dataIndex: "EventUserFullName",
                propertyType: enmPropertyType.string,
                controlType: enmControlType.textbox,
                sortable: false
            },
            {
                title: "تاریخ و زمان رخداد",
                dataIndex: "EventDateTime",
                propertyType: enmPropertyType.datetime,
                controlType: enmControlType.datetime
            },
            {
                title: "شرح عملیات",
                dataIndex: "EventTitle",
                propertyType: enmPropertyType.string,
                controlType: enmControlType.textbox
            },
            {
                title: "وضعیت",
                dataIndex: "State",
                propertyType: enmPropertyType.string,
                controlType: enmControlType.textbox,
                sortable: false,
                renderColumn: (value: enmEntityState) => {
                    switch (value) {
                        case enmEntityState.Added:
                            return "ایجاد";
                        case enmEntityState.Modified:
                            return "ویرایش";
                        case enmEntityState.Deleted:
                            return "حذف";
                        default:
                            return "بدون تغییر";
                    }
                }
            }
        ];

        const columns = [
            ...properties,
            ...this.props.metadata.Properties.map(p => { return { ...p, sortable: false } })
        ].filter(c => c.showColumn !== false).map(c => {
            let newCol: ColumnType<any> = {};
            newCol.key = c.key ?? c.dataIndex;
            newCol.title = c.title;
            newCol.dataIndex = c.dataIndex;
            newCol.width = c.width;

            newCol.responsive = ['lg', 'md', 'sm', 'xs'];
            newCol.render = (text, record, index) => {
                let result: any = null;
                if (c.renderColumn) {
                    result = c.renderColumn(text, record, index);
                }

                if (c.lookup?.lookupComponent && record) {
                    let displayData = record as any;
                    if (displayData[c.lookup?.lookupProperty!])
                        return (
                            <div key={record.RowGuid} style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                                <Col>{c.lookup?.lookupDisplayFields?.map(f => {
                                    let fields = f.split('.');
                                    let value = displayData[c.lookup?.lookupProperty!];
                                    fields.forEach(i => {
                                        value = value[i];
                                    });
                                    return value + " "
                                })}</Col>
                            </div>
                        );
                }

                result = result ?? text;

                let fields = c.dataIndex?.split('.');
                let value = record as any;
                fields?.forEach(i => {
                    if (value !== undefined && value !== null && value[i] !== undefined && value[i] !== null)
                        value = value[i];
                    else
                        value = undefined;
                });

                if (c.propertyType === enmPropertyType.boolean) {
                    return (<Checkbox key={record.RowGuid} checked={value} />);
                }
                if (c.combobox && (c.combobox.options || c.combobox.optionsFunc)) {
                    return (
                        <div key={record.RowGuid} style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                            {c.combobox.options?.find(o => o.value === value)?.title}
                            {c.combobox.optionsFunc && c.combobox.optionsFunc(this, record).find(o => o.value === value)?.title}
                        </div>
                    );
                }
                if (c.propertyType === enmPropertyType.date) {
                    result = text ? dayjs(text).calendar('jalali').locale('fa').format("YYYY/MM/DD") : undefined;
                    return (<div key={record.RowGuid} style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                        {result}
                    </div>);
                }
                if (c.propertyType === enmPropertyType.datetime) {
                    result = value ? dayjs(value).calendar('jalali').locale('fa').format("YYYY/MM/DD HH:mm") : undefined;
                    return (<div key={record.RowGuid} style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                        {result}
                    </div>);
                }
                if (c.controlType === enmControlType.numberinput) {
                    result = text;
                    if (value)
                        result = value;
                    return (<div key={record.RowGuid} style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                        {c.formatter ? c.formatter(result, {} as any) : result}
                    </div>);
                }
                if (c.controlType === enmControlType.priceinput) {
                    result = text;
                    if (value)
                        result = value;
                    return (<div key={record.RowGuid} style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                        {`${result}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                    </div>);
                }
                if (!result && !!value)
                    result = value;
                return (
                    <div key={record.RowGuid} style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                        {result}
                    </div>
                );
            };
            newCol.sorter = c.sortable !== false;
            newCol.onCell = (data) => {
                return {
                    style: (data.ModifiedColumns as string[])?.indexOf(c.dataIndex!) > -1 ? { backgroundColor: "lightblue" } : (data.State === 1 ? { backgroundColor: "greenyellow" } : {})
                };
            };
            return newCol;
        });

        return columns;
    }
    virtualRender() {
        const header = this.getPageHeader({
            title: this.title,
            onBack: () => { this.props.onClose && this.props.onClose(this) }
        });

        const data = this.state.entities.map(e => {
            let item: any = {
                EventId: e.AuditLog.EventId,
                EventUserFullName: e.AuditLog.EventUserFullName,
                EventDateTime: e.AuditLog.EventDateTime,
                EventTitle: e.AuditLog.EventTitle,
                ModifiedColumns: e.ModifiedColumns
            };

            let entity = e.Entity;
            if (!!entity) {
                for (let key in entity)
                    item[key] = entity[key];
            }
            return item;
        });

        const loading = this.state.loading ? { indicator: <CustomSpinner /> } : false;

        const { PageSize, PageNo } = this.state.paging;
        const { Property, OrderBy } = this.state.ordering;

        return (
            <>
                {header}

                <Table
                    rowKey={a => a.EventId}
                    columns={this.columns}
                    dataSource={data}
                    bordered
                    scroll={{ x: 'max-content' }}
                    loading={loading}
                    onChange={(pagination, _, sorter) => {
                        let ordering: IOrdering = { Property, OrderBy };
                        let paging: IPaging = { PageNo, PageSize };
                        if (!(sorter instanceof Array) && sorter.field) {
                            ordering = {
                                Property: "AuditLog." + sorter.field?.toString() ?? '',
                                OrderBy: sorter.order === 'ascend' ? enmOrderingType.Ascending : enmOrderingType.Descending
                            };
                        }
                        paging = {
                            PageNo: pagination.current ?? 1,
                            PageSize: pagination.pageSize ?? 10
                        };

                        this.initialize(paging, ordering);
                    }}
                    pagination={{
                        style: { marginRight: 10 },
                        position: ['bottomRight'],
                        responsive: true,
                        defaultPageSize: PageSize,
                        current: Math.ceil(this.state.totalResultCount ?? 0 / PageSize) < PageNo ? 1 : PageNo,
                        total: this.state.totalResultCount,
                        showSizeChanger: true,
                        size: 'small',
                        showTotal: (total, _) => {
                            return (<div>تعداد کل ردیف ها: {total} </div>);
                        }
                    }}
                />
            </>
        );
    }
}

export default AuditLogItems;